<template>
	<v-autocomplete
		:label="$attrs.label || $t('sgp.event')"
		:items="Events"
		:loading="LoadingEvents"
		item-text="Name"
		item-value="EventId"
		v-bind="$attrs"
		v-bind:value="value"
		v-on="$listeners"
		@input="$emit('input', value)"
		:search-input.sync="search"
		clearable
	></v-autocomplete>
</template>
<script>
import CrudClient from "@/services/CrudClient/";
import { mapActions } from "vuex";

export default {
	data() {
		return {
			LoadingEvents: false,
			Events: [],
			search: null,
			requestNo: 0,
		};
	},
	props: {
		value: { type: Number, default: null },
		EventType: { type: Number, default: 1 },
		// addEmptyItem: { type: Boolean, required: false, default: false },
	},
	created() {
		this.SgpEventsService = new CrudClient("SGP/Events");
	},
	watch: {
		async search(val) {
			this.$log.debug("Watch search: " + val);
			val && val !== this.value && val.length > 0 && (await this.LoadEvents(val));
		},

		value: {
			immediate: true,
			handler: async function (newVal) {
				if (!newVal) return;
				// Programmatic value set
				if (!this.Events.find((i) => i.EventId === newVal)) {
					const res = await this.SgpEventsService.GetSelectedFields(
						newVal,
						"Name, EventId"
					);

					this.search = res.Name;
				}
			},
		},
	},
	async mounted() {
		// await this.LoadEvents();
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),
		async LoadEvents(val) {
			try {
				this.LoadingEvents = true;

				const currentRequestNo = ++this.requestNo;

				const res = await this.SgpEventsService.GetPaged({
					skip: 0,
					limit: 10,
					filter: `EventType:${this.EventType};Name:like:${encodeURIComponent(val)}`,
					fields: "EventId, Name",
					orderBy: "EventId:desc",
				});

				// if there is no other request after this one
				if (this.requestNo === currentRequestNo) {
					this.Events = res.Data;
				}
			} catch (error) {
				this.$captureError(error);
				this.snackError({ Text: this.$t("common.error.cannotLoadData") });
			} finally {
				this.LoadingEvents = false;
			}
		},
	},
};
</script>
